import * as React from 'react';
import './trialHeader.module.scss';
import { HeaderItem, HeaderItemMainText, HeaderItemSubText } from './HeaderItem';
import { useObserver } from 'mobx-react';
import { useViewportState } from '../../../../../commonv3/hooks/useViewportState';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { DesktopNavigation } from './DesktopNavigation';
import { MobileNavigation } from './MobileNavigation';

export type TrialHeaderBackground = 'transparent' | 'white';

type TrialHeaderProps = {
    background: TrialHeaderBackground;
    headerItems: ItemProps[];
    topUrl: { pathname: string; hash: string } | string;
};

type LocationSpec = { pathname: string; hash: string } | string;
type LocationSpecFactory = () => LocationSpec;
type DestinationSpec = LocationSpec | LocationSpecFactory | URL;

type ItemProps = {
    to: DestinationSpec;
    // The main text (capital letters) e.g. SUPPORT
    mainText: string;
    // The sub test e.g. サポート
    subText: string;
    // The long sub text for sp e.g. なりたい姿を叶えるためのサポート
    longSubText: string;
    // If set, only show this item when the condition is met
    showIf?: () => boolean;
};

export const TrialNavigation = ({ background, headerItems, topUrl }: TrialHeaderProps) => {
    return useObserver(() => {
        const { isMobile, isDesktop } = useViewportState();
        const headerContent = headerItems.map((item, index) => {
            if (item.showIf && !item.showIf()) {
                return null;
            }
            const destination = () => {
                if (typeof item.to === 'string' && item.to.includes('http')) {
                    location.href = item.to;
                    return null;
                }
                const to = typeof item.to === 'function' ? item.to() : item.to;
                return GlobalStatesV3.routing.push(to as any);
            };
            return (
                <HeaderItem
                    key={index}
                    color={isDesktop && background === 'transparent' ? 'white' : 'dark'}
                    onClick={destination}
                >
                    <HeaderItemMainText>{item.mainText}</HeaderItemMainText>
                    <HeaderItemSubText>{isDesktop ? item.subText : item.longSubText}</HeaderItemSubText>
                </HeaderItem>
            );
        });
        if (isMobile) {
            return (
                <MobileNavigation background={background} topUrl={topUrl}>
                    {headerContent}
                </MobileNavigation>
            );
        } else {
            return (
                <DesktopNavigation background={background} topUrl={topUrl}>
                    {headerContent}
                </DesktopNavigation>
            );
        }
    });
};
